import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

import { AuthModeService } from "../_services/auth-mode.service";
import { AuthenticationService } from "../_services/authentication.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  private authService = inject(AuthenticationService);
  private authMode = inject(AuthModeService);
  private router = inject(Router);

  canActivate(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      take(1),
      map(isAuthenticated => {
        if (!isAuthenticated) {
          if (this.authMode.mode === "portal") {
            void this.authService.login(state.url);
          } else {
            void this.router.navigate(["/login"]);
          }
          return false;
        }
        return true;
      })
    );
  }
}
